import React from "react";
import ogrWhiteLogo from "images/ogr_logo_white.png";
import googlePlay from "images/google_play_store.png";
import appStore from "images/apple_store.png";
import footerBackground from "images/footer_bg.png";
import add from "images/add.png";
import AdultIcon from "images/eighteenplusicon.webp"
import BeGambleAwareLogo from "images/begambleaware-logo.svg";
import fb from "images/fb.png";
import instagram from "images/instagram.png";
import twitter from "images/twitter.png";
import linkedin from "images/linkedin.png";
import phone from "images/phone.png";
import mail from "images/mail.png";
import Link from "helpers/link";

const app = "https://apps.apple.com/gb/app/old-gold-racing/id1599057634";
const apk = "https://play.google.com/store/apps/details?id=com.ogr.app";

const Footer = ({ data, social }) => {
  return (
    <main className="bg-indigo-900 py-8 sm:px-3">
      <div className="container flex sm:flex-col justify-between text-gray-300 text-[12px]">
        <div className="flex justify-left w-1/3 sm:w-full">
          <div className="flex flex-col justify-evenly">
            <img
              src={ogrWhiteLogo}
              alt="OGR Logo"
              className="h-[33px] w-[70px] my-[8px]"
            />
            <p className="my-[8px]">
              Download the app by clicking the link below :
            </p>
            <div className="flex self-start my-[8px]">
              <a href={app} target="_blank" rel="noopener noreferrer">
                <img
                  src={appStore}
                  alt="App Store"
                  className="h-[33px] w-[100px]"
                  target="_blank"
                />
              </a>
              <a href={apk} target="_blank" rel="noopener noreferrer">
                <img
                  src={googlePlay}
                  alt="Google Play"
                  className="ml-[17px] ms:ml-[0px] h-[33px] w-[100px]"
                  target="_blank"
                />
              </a>
            </div>
          </div>
        </div>

        <div className="w-1/3 sm:w-full flex justify-between sm:mt-5 sm:mb-8">
          <div className="text-indigo-200">
            {data?.links &&
              data.links.map(({ text, url }, index) => (
                <Link
                  className="py-2.5 cursor-pointer block"
                  to={url}
                  key={index}
                  target="_blank"
                >
                  {text}
                </Link>
              ))}
          </div>

          <div className="text-indigo-200">
            {data?.additionalLinks &&
              data.additionalLinks.map(({ text, url }, index) => (
                <Link
                  className="py-2.5 cursor-pointer block"
                  to={url}
                  key={index}
                >
                  {text}
                </Link>
              ))}
          </div>
        </div>

        <div className="flex justify-center w-1/3 sm:w-full">
          <div className="my-2 flex flex-col sm:items-center">
            <div className="flex py-2.5">
              <Link to={`tel:${social.phone}`} className="flex">
                <div className="w-[17px] h-[17px] mr-[12px]">
                  <img src={phone} alt="phone" className="h-full" />
                </div>
                <p>{social.phone}</p>
              </Link>
            </div>
            <div className="flex py-2.5">
              <Link to={`mailto:${social.email}`} className="flex">
                <div className="w-[17px] h-[17px] mr-[12px]">
                  <img src={mail} alt="mail" className="h-full" />
                </div>
                <p>{social.email}</p>
              </Link>
            </div>
            <div className="flex py-2.5">
              <div className="w-6 h-6 mr-3">
                <a
                  href={social.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={fb} alt="fb" className="h-full" />
                </a>
              </div>
              <div className="w-6 h-6 mx-3">
                <a
                  href={social.twitter}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={twitter} alt="twitter" className="h-full" />
                </a>
              </div>
              <div className="w-6 h-6 mx-3">
                <a
                  href={social.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={linkedin} alt="linkedin" className="h-full" />
                </a>
              </div>
              <div className="w-6 h-6 ml-3">
                <a
                  href={social.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={instagram} alt="instagram" className="h-full" />{" "}
                </a>
              </div>
            </div>
            <div className="flex py-2.5 gap-4 items-center sm:justify-center justify-start">
              <img src={BeGambleAwareLogo} loading="lazy" decoding="async" alt="BeGambleAware" className="h-10 w-1/2" />
              <img src={AdultIcon} loading="lazy" decoding="async" alt="Adult Only" className="h-6" />
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Footer;
